import i18n from 'i18n-js'
// migrating those to i18next
export const en = {
  strCommon: {
    confirm: 'confirm',
    of: 'of',
    cancel: 'cancel',
  },
  strCommonUI: {
    button: {
      signIn: 'Sign in',
      signOut: 'Sign out',
      continue: 'Continue',
      accessAccount: 'Access my account',
      updateInfo: 'Update info',
      completeProfile: 'Complete profile',
      updateDetails: 'Update details',
      updateEmail: 'Update email',
      updatePassword: 'Update password',
      save: 'Save',
      rename: 'Rename',
      delete: 'Delete',
      cancel: 'cancel',
      add: 'add',
      addPlayers: 'Add players',
      createWatchlist: 'Create watchlist',
      remove: 'remove',
      update: 'update',
      updated: 'updated',
      edit: 'edit',
      back: 'back',
      submit: 'submit',
      confirm: 'confirm',
      postScore: 'post score',
      reject: 'reject',
      accept: 'accept',
      okGotIt: 'Ok, got it',
      singles: 'Singles',
      doubles: 'Doubles',
      subscribe: 'subscribe',
      postAScore: 'Post a score',
      new: 'NEW',
      join: 'join',
      yesDelete: 'yes, delete',
      noCancel: 'no, cancel',
      close: 'close',
      done: 'done',
      clear: 'Clear',
      clearTextField: 'clear text field',
      applyFilter: 'Apply filter',
      exportCsv: 'Export to CSV',
      manage: 'Manage',
      seeError: 'see error details',
      copyToClipboard: 'Copy to clipboard',
      register: 'Sign up',
    },
    link: {
      here: 'here',
      clickHere: 'Click here',
      back: 'Back',
      backTo: 'Back to %{name}',
      myProfile: 'My profile',
      myAccount: 'My account',
      myWatchlists: 'My watchlists',
      goToWatchlists: 'Go to My watchlists',
    },
    select: {
      pleaseChoose: 'Please choose...',
    },
    form: {
      allFieldsMandatory: 'All fields are mandatory unless otherwise stated.',
      required: 'is required',
      invalid: 'is invalid',
      consent: 'Consent',
      firstName: 'Given name',
      lastName: 'Family name',
      dob: 'Date of birth',
      inputDayPlaceholder: 'dd',
      inputMonthPlaceholder: 'mm',
      inputYearPlaceholder: 'yyyy',
      sex: 'Sex',
      sexMale: 'Male',
      sexFemale: 'Female',
      nationality: 'Nationality',
      residence: 'Country of residence',
      email: 'Email',
      password: 'password',
      watchlistName: 'watchlist name',
      parentGuardianName: 'Parent or guardian full name',
      parentGuardianEmail: 'Parent or guardian email',
      whereDidYouHearAboutUs: 'Where did you hear about us? (Optional)',
      validationErrors: {
        minMaxChars: 'must be between %{minLength} and %{maxLength} characters long',
        maxChars: '%{name} must be less than %{maxLength} characters long',
        dobInThePast: 'Date of birth must be a past date',
        minAgeToRegister: 'You must be at least %{minAge} to register for WTN',
        minAgeForService: 'You must be at least %{minAge} to use WTN',
        minHeight: 'Min allowed height is: %{minHeightMetric} (%{minHeightImperial})',
        maxHeight: 'Max allowed height is: %{maxHeightMetric} (%{maxHeightImperial})',
        onlyAlphanumeric: 'Only alphanumeric values are allowed',
        watchlistNameRequired: 'Please add a name for the watchlist',
        watchlistNameExists: 'You already have a watchlist with this name',
      },
    },
    placeholder: {
      searchResidence: 'Type residence...',
      searchNationality: 'Type nationality...',
      searchNA: 'Type National Assocation...',
    },
    ariaLabel: {
      accountMenu: 'Account Menu',
      pendingMatchMenu: 'Social match options menu',
      moreInfo: 'More info',
      moreOptions: 'More options',
      noRating: 'No rating available',
      watchlistIncludedBtn: 'Player included in Watchlist, click to remove player',
      watchlistNotIncludedBtn: 'Player not included in Watchlist, click to add player',
      loading: 'Loading',
    },
  },
  strSearchBar: {
    placeholderDefault: 'Search',
    placeholder: 'Type surname or Tennis ID...',
    viewAll: 'See all %{type}',
    notFound: 'No %{type} found',
    player: 'player',
    players: 'players',
    vs: 'VS',
    h2hSearchCompare: 'Choose players to compare in the boxes above',
    h2hSingleSearchCompare: 'Choose a player to compare in the box above',
  },
  strFilterBar: {
    genderDefaultLabel: 'Any Gender',
    male: 'Male',
    female: 'Female',
    anyGender: 'Gender',
    anyGenderOption: 'Any gender',
    nonBinary: 'Non-Binary',
    anyAgeGroup: 'Age group',
    ageGroupCompositeDropdownLabel: 'Age: %{ageGroup}',
    ageGroupBornInLabel: 'Born %{birthYear}',
    countries: 'Countries',
    yes: 'yes',
    no: 'no',
    filterBy: 'Filter by',
    countryDefaultLabel: 'Nationality',
    nationalityCompositeDropdownLabel: 'Nationality: +%{numberSelected}',
    clearFilter: 'Clear filter',
    countryFilterPlaceholder: 'Type to filter...',
    rating: {
      radioAllPlayers: 'All players',
      radioRatingRange: 'Rating range',
      labelDropdownCombined: 'WTN Rating',
      labelRatingType: 'Rating type',
      labelConfidenceLevel: 'Confidence level',
      defaultLabelSingles: 'Singles number',
      defaultLabelDoubles: 'Doubles number',
      radioSingles: 'Singles',
      radioDoubles: 'Doubles',
      radioConfidenceHigh: 'High confidence (verified)',
      radioConfidenceAll: 'All',
      compositeDropdownLabel: '%{appliedLabel}: %{min}-%{max}',
      inputError: 'Allowed values are between %{max} and %{min} with only one decimal.',
      confidenceModal: {
        title: 'Number Verification',
        tickHigh: 'Blue confidence ribbon',
        tickLow: 'Grey confidence ribbon',
        exampleNumber: 'Example number',
      },
    },
    wtnRange: 'WTN Range',
    apply: 'APPLY FILTER',
    cancel: 'CANCEL',
    rangeLabel: '%{range} Rating',
    rangeLabelSingles: 'Singles number',
    rangeLabelDoubles: 'Doubles number',
    clearFilters: 'Clear filters',
    filters: 'Filters',
    minRating: 'Min rating',
    maxRating: 'Max rating',
  },
  searchResults: {
    wtn: 'WTN',
    searching: 'Searching for results...',
    tableResultsInfo: 'Showing %{showing} of 1000s of results',
    tableResultsInfoWithTotal: 'Showing %{showing} of %{total} results',
    nationalityHeading: 'Nationality',
    ageGroupHeading: 'Age group',
    playersHeading: 'Players',
    singlesHeading: 'Singles number',
    doublesHeading: 'Doubles number',
    age: 'Age',
    loadMore: 'LOAD MORE',
    showMore: 'SHOW MORE',
    noPlayers: 'No players found. Please input a player name, before applying the filters',
    modalHeader: 'Head to head results',
  },
  strCharts: {
    singles: 'Singles',
    doubles: 'Doubles',
    both: 'Both',
    wins: 'Wins',
    losses: 'Losses',
    winLossRecordsKey: ['Wins', 'Losses', 'Walkovers', 'Retirements'],
    wtnHistory: 'WTN History',
    singlesWinLoss: 'Singles win-loss record',
    doublesWinLoss: 'Doubles win-loss record',
    bothWinLoss: 'Singles and Doubles win-loss record',
    errorFetchingData: 'There has been an error fetching the data. Please retry later.',
    noData: 'No results available for the selected date range',
    noDataShort: 'No results available',
    noDataGeneric: 'Sorry, there is no data available',
    noDataTournaments: 'Sorry, there is no data available. Please select another year',
  },
  strDateFilter: {
    allTime: 'All time',
    oneMonth: 'Last Month',
    nMonths: 'Last %{months} months',
    nYears: 'Last %{years} years',
  },
  strMobileFilter: {
    filters: 'Filters',
    filtersWithCount: 'Filters (%{count})',
    filtersAndSort: 'Filters and Sort',
    filtersAndSortWithCount: 'Filters and Sort (%{count})',
    gameType: 'Game type',
    year: 'year',
    reset: 'Reset',
    clearAll: 'Clear all',
    gender: 'Gender',
    ageGroup: 'Age group',
    anyAgeGroupOption: 'Any age group',
    nationality: 'Nationality',
    anyNationality: 'Any nationality',
    rating: 'WTN Rating',
    anyRating: 'All players',
    sortBy: 'Sort by',
    sortingLabelSingles: 'Singles number',
    sortingLabelDoubles: 'Doubles number',
    sortingLabelName: 'Player name',
    cancel: 'Cancel',
    goBack: 'Back',
    updateFilters: 'Apply Filters',
    timePeriod: 'Time period',
  },
  strProfileHeader: {
    age: 'Age',
    bornIn: 'Born in',
    under: 'Under',
    editProfile: 'Edit profile',
    addToWatchlist: 'Add to watchlist',
    removeFromWatchlist: 'Remove from watchlist',
    singlesWtn: 'Singles WTN',
    doublesWtn: 'Doubles WTN',
    WTNDefinition:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    additionalInfo: 'Additional Info',
    residence: 'Residence',
    eventsPlayed: 'Events played',
    preferredHand: 'Preferred hand',
    height: 'Height',
    favouriteShot: 'Favourite shot',
    backhand: 'Backhand',
    clubsAssociations: 'Clubs & associations',
  },
  strGuidedTour: {
    overview: {
      title: 'Overview',
      content:
        'Find your real-time ITF World Tennis Number, Game zOne, match statistics and your rating history.',
    },
    results: {
      title: 'Results',
      content: 'See all the match results we have for you. You can filter months, days and years.',
    },
    headToHead: {
      title: 'Head-to-Head',
      content:
        'Search and compare yourself with other players in the ITF World Tennis Number community.',
    },
    yourNumber: {
      title: 'Your number',
      content: 'Compare Numbers with others, look at your match history and competitors in common.',
    },
    watchlist: {
      title: 'Watchlist',
      content: 'Keep a track of your favourite players, friends, colleagues, and family.',
    },
    competitions: {
      title: 'Competitions',
    },
    myMatches: {
      title: 'My Matches',
    },
  },
  strScaleModal: {
    aboutWTNHeader: 'About World Tennis Number',
    aboutWTNContent:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam minima tenetur nisi obcaecati nihil aliquam dolor accusantium nemo eum rem, quis, non molestiae eos possimus praesentium pariatur, provident doloribus nostrum.',
  },
  strProfile: {
    sections: {
      overview: 'overview',
      results: 'results',
      h2h: 'head-to-head',
      competitions: 'competitions',
      socialMatches: 'my matches',
    },
    overview: 'Overview',
    playerStats: 'Player Stats',
    comparePlayers: 'Compare players',
    headToHead: 'Head to Head',
    wtnHistory: 'World Tennis Number history',
    playerTournMatches: 'Player tournament matches',
    resultsSummary: 'Results summary',
    h2hSearchDescription: 'Select players to compare %{name} to',
    pageNotFound: 'The page you requested cannot be found.',
    invalidPlayerId: 'This player ID is invalid',
    error: 'Error',
    defaultErrorMsg: 'Something went wrong...',
    problemLoadingProfile: 'Encountered an error while loading this players profile. ',
    navigateBack: 'Please navigate back to the',
    homepage: 'homepage',
    notFound: 'Player Not Found',
    selectAnotherPage: 'or select another page from the navigation menu.',
  },
  strSocialMatches: {
    submitAScore: {
      title: 'Post a score',
      info: 'Add a result of a tennis match you played',
    },
    myScores: {
      title: 'my scores',
      titleOther: 'scores',
      info: {
        pending:
          'Pending scores will be automatically accepted after 72 hours from the date of submission.',
        rejected:
          'Rejected scores will be automatically deleted after 3 months from the date of submission.',
      },
      submitted: 'accepted',
      pending: 'pending',
      rejected: 'rejected',
      matchCard: {
        menu: {
          delete: 'Delete score',
        },
        pending: {
          info: 'waiting for your opponent to accept this score',
        },
        rejected: {
          info: {
            opponent: 'score rejected by opponent',
            me: 'score rejected by you',
            partner: 'score rejected by your partner',
          },
        },
      },
      noScoresPanel: {
        getStarted: {
          title: 'Let’s get started!',
          info: 'Your scores will appear here after you post them',
        },
        approved: {
          title: 'You don’t have accepted scores yet',
          info: 'Accepted scores will appear here once you or your opponent accept them',
        },
        pending: {
          title: 'You don’t have pending scores currently',
          info: 'Your pending scores will appear here after you or your opponent post them',
        },
        rejected: {
          title: 'You don’t have rejected scores',
          info: 'Your rejected scores will appear here if you or your opponent reject a pending score',
        },
        otherPlayer: {
          title: 'No matches found',
          info: '%{firstName} hasn’t posted any matches yet',
        },
      },
    },
    modals: {
      approve: {
        header: 'accepting score',
        info: {
          1: 'you’ll see this score publicly posted on your profile immediately.',
          2: 'are you sure you want to accept the score?',
        },
        checkbox: 'Don’t show this again',
      },
      reject: {
        header: 'rejecting score',
        info: {
          1: 'this score will be deleted and will not be publicly posted anywhere.',
          2: 'are you sure you want to reject the score?',
        },
        checkbox: 'Don’t show this again',
      },
      delete: {
        header: 'delete score',
        info: {
          1: 'Are you sure you want to delete the score played on %{datePlayed}?',
          2: 'This action cannot be reversed.',
        },
      },
      addPlayer: {
        header: 'Add player',
        searchBarLabel: 'Search for a player',
        addPlayer: 'Add player',
        added: 'Already added',
        shareLinkBtn: 'Copy registration link',
        selectPlayer: 'Select the player you would like to add:',
      },
      infoPending: {
        header: 'Pending score',
        info: {
          1: 'Your opponent or partner will have 72 hours to accept or reject the score. If the score has not been responded to, it will automatically be accepted.',
          2: 'Only when your opponent has approved it will it appear on all player accounts.',
        },
      },
    },
    postScore: {
      title: 'Post your score',
      subtitle: 'Post your score for calculation towards your World Tennis Number',
      modals: {
        info: {
          title: 'Submit score info',
          info: {
            1: 'Self-submitted scores are not verified.',
            2: 'Scores won’t be publicly posted to your opponent’s profile or count towards your World Tennis Number until they have been approved by your opponent.',
            3: 'If you’ve made a mistake, you can easily delete and resubmit the score.',
          },
        },
      },
      links: {
        backToMyScores: 'Go to my scores',
      },
      matchDate: { title: 'Match date' },
      matchType: { title: 'Match type' },
      matchFormat: {
        title: 'Match format',
        options: {
          '3s6g': { name: '3 Sets: First to 6 games' },
          '2s6g': { name: '2 Sets: First to 6 games' },
          '2s4g': { name: '2 Sets: First to 4 games' },
          '1s6g': { name: '1 Set: First to 6 games' },
          '10p': { name: 'First to 10 points' },
        },
        infoBoxTitle: 'What does this match format mean?',
      },
      matchScore: {
        title: 'Enter scores',
        playerCard: {
          addPlayer: 'Add player',
          winner: 'wins',
          sideRef: {
            singles: 'Player',
            doubles: 'Team',
          },
        },
        label: {
          set: 'set',
          tiebreak: 'tiebreak',
          superTiebreak: 'tiebreak',
        },
      },
      success: {
        title: 'Score submitted - Thanks',
        list: {
          info: "You'll see this publicly posted on your profile once your opponent:",
          1: 'signs up to ITF World Tennis Number',
          2: 'and confirms the result',
        },
        btn: {
          back: 'back to results',
          submitNew: 'submit new score',
        },
      },
      scoreValidationError: {
        invalidScore: 'Invalid score entry',
      },
    },
  },
  strPlayerStats: {
    matchActivityTitle: 'Match activity',
    daysSinceLastMatchTitle: 'Days since last match:',
    uniqueSinglesTitle: 'Unique singles opponents:',
    singlesIntervalTitle: 'Average singles interval:',
    doublesIntervalTitle: 'Average doubles interval:',
    ratingHighsAndLows: 'Rating range',
    lowestTitle: 'Lowest',
    highestTitle: 'Highest',
    pastYeartitle: 'Past Year',
    allTimeTitle: 'All Time',
    days: 'days',
    singles: 'Singles',
    doubles: 'Doubles',
  },
  strMatchHistory: {
    matchHistory: 'Match history',
    noMatchHistory: 'No match history found',
    date: 'Date',
    tournament: 'Tournament',
    draw: 'Draw',
    winner: 'Winner',
    score: 'Score',
    headToHead: 'Head-to-Head',
    percentageWins: '% wins',
    wtn: 'WTN',
    time: 'time',
    times: 'times',
    notCompeted: 'These players have not competed',
    close: 'Close',
  },
  strH2H: {
    age: 'Age',
    yearOfBirth: 'Birth Year',
    gender: 'Gender',
    nationality: 'Nationality',
    wtnSingles: 'SINGLES NUMBER',
    wtnDoubles: 'DOUBLES NUMBER',
    wins: { one: 'win', other: 'wins' },
    winsWithCount: { one: '%{count} win', other: '%{count} wins' },
    totalWins: 'Total wins',
  },
  strMatchResults: {
    matchResults: 'match results',
    competitions: {
      title: 'Competition results',
      modal: {
        header: 'Competitions',
      },
    },
    social: {
      title: 'My match results',
      modal: {
        header: 'My Matches',
      },
    },
    dateRound: 'Date',
    players: 'players',
    score: 'score',
    noResults: { title: 'No results found', info: "Sorry, we couldn't seem to get any results." },
    openAllResults: 'Open all results',
    closeAllResults: 'Close all results',
  },
  strCommonCompetitors: {
    commonCompetitors: 'Competitors in common',
    player: 'Player',
    winLoss: 'W / L',
    winPercent: 'WIN %',
    totals: 'TOTAL',
    noCommonCompetitors: 'These players have no common competitors during this period',
    showMore: 'Show more',
  },
  strRecentOpponents: {
    header: 'Recent opponents',
    thisPlayer: 'this player',
    sortBy: 'Sort by:',
    date: 'Date',
    opponent: 'Opponent',
    winLoss: 'W-L',
    w: 'W',
    l: 'L',
    score: 'Score',
    winLossRecord: 'W/L record',
  },
  strDates: {
    monthsShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    monthsLong: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  },
  strMyAccount: {
    myDetails: 'My details',
    changePassword: 'Change password',
    signInDetails: {
      title: 'Sign in details',
      subtitle: 'Below you’ll be able to update your sign in details.',
      bodyTitle: 'Update details',
    },
    accountUpToDate: 'Please keep your account details up to date.',
    avatar: 'Avatar',
    editAvatar: 'Edit avatar',
    uploadPhotoText: 'You can pick an ITF avatar.',
    tennisId: 'Tennis ID',
    playerProfile: 'Player profile',
    infoText: 'If you would like to update your details, please',
    infoError:
      'Sorry, an error occurred while retrieving your details. Please refresh or try again later.',
    contactUs: 'contact us',
    playerInfo: 'Player info',
    privacyAndConsents: {
      title: 'Privacy & consents',
      subtitle: 'Choose who can see you and manage your communication preferences.',
      bodyTitle: 'Your preferences',
    },
    logout: 'Logout',
  },
  strEditProfile: {
    editProfile: 'Edit Profile',
    profile: 'Profile',
    playerInfo: 'Player info',
    clubsAssociations: 'Clubs & associations',
    inputFirstName: 'First name',
    inputLastName: 'Last name',
    inputNickName: 'Nickname',
    inputNickNamePlaceholder: 'Enter Nickname',
    inputNationality: 'Nationality',
    inputDoB: 'Date of birth',
    inputDayPlaceholder: 'DD',
    inputMonthPlaceholder: 'MMM',
    inputYearPlaceholder: 'YYYY',
    inputSex: 'Sex',
    inputFemale: 'Female',
    inputMale: 'Male',
    inputGender: 'Gender',
    inputResidence: 'Country of residence',
    inputResidencePlaceholder: 'Search...',
    inputHeight: 'Height',
    inputHeightPlaceholder: '75cm - 225cm',
    inputMetric: 'Metric',
    inputImperial: 'Imperial',
    inputPreferredHand: 'Preferred hand',
    optsPreferredHandRight: 'Right',
    optsPreferredHandLeft: 'Left',
    inputBackhand: 'Backhand',
    optsBackhandSingle: 'Single',
    optsBackhandTwo: 'Two handed',
    inputFavouriteShot: 'Favourite shot',
    inputFavouriteShotPlaceholder: 'Please choose...',
    optsFavouriteShotForehand: 'Forehand',
    optsFavouriteShotBackhand: 'Backhand',
    optsFavouriteShotServe: 'Serve',
    optsFavouriteShotVolley: 'Volley',
    optsFavouriteShotSmash: 'Smash',
    optsFavouriteShotDropShot: 'Drop shot',
    dropdownPlaceholder: '-- select an option --',
    update: 'Update',
  },
  strSelectAvatar: {
    selectAvatar: 'Select avatar',
    chooseAvatar: 'Choose an avatar',
    chooseStyle: 'Choose a style',
    uploadPhoto: 'Upload photo',
    pickItfAvatar: 'pick ITF avatar',
    cancel: 'CANCEL',
    setAsMyAvatar: 'Set as my Avatar',
  },
  strUploadImage: {
    fileUploadText: 'Max file size of 4 MB. JPG or PNG',
    fileSizeError: {
      1: 'Sorry, the image you’re trying to upload is larger than 4 MB.',
      2: 'Please reduce the size and try again.',
    },
    fileTypeError: {
      1: 'Sorry, the format of the image you’re trying to upload is not supported.',
      2: 'The supported formats are JPG and PNG.',
    },
    buttonText: 'Upload file',
    uploadFromDevice: 'Upload from your device',
    changePhoto: 'Change photo',
    dragAndDropHere: 'Drag and drop your image here',
    dragAndDropBelow: 'Drag and drop your image below',
    or: 'or',
    update: 'update',
    remove: 'remove',
    uploadAnotherPhoto: 'Upload another photo',
    dragToReposition: 'Drag to reposition and size your photo',
  },
  strData: {
    noPlayerName: 'Unknown Player',
    unknown: 'Unknown',
    optOutPlayerName: 'Player',
    na: 'N/A',
    pro: 'PRO',
    male: 'Male',
    female: 'Female',
    unspecified: 'Unspecified',
    ellipsis: '...',
    single: 'Single',
    double: 'Double',
    left: 'Left handed',
    right: 'Right handed',
    ambidextrous: 'Ambidextrous',
  },
  strRegister: {
    header: 'Welcome',
    subheader: 'Create your account',
    commConsentItf:
      'Yes, I would like to receive news, information, and special offers from the ITF',
    commConsentNa:
      'Yes, I would like to receive emails from my National Association for marketing purposes',
    parentalConsent: {
      fastTrack: {
        title: 'Parent/Guardian',
      },
      infoBox: {
        title: 'Under 18 registrations',
        info: 'If you are under 18 years of age you must ask your parents or legal guardian’s consent before you register for an account on worldtennisnumber.com.',
      },
      helpText: 'Please provide the name and email address of your parent or legal guardian.',
    },
  },
  strFastTrackRegistration: {
    accountCreated: 'Your account has been created!',
    welcome: 'Welcome',
    features: {
      one: 'Match activity',
      two: 'Personalised GameZone',
      three: 'ITF World Tennis Number history',
    },
    checkDetails: 'Please check your details below to make sure they’re correct',
    residenceTooltip: {
      partOne:
        'Knowing your country of residence enable us to support your queries and improve your experience.',
      partTwo:
        'If you reside in several countries, please choose the one where you play tennis tournaments more often.',
    },
    residenceInfoQuestion: 'What if I reside in several countries?',
  },
  strMessageScreen: {
    backToHome: 'Back to home page',
    pageNotFound: 'Page not found',
    pageNotFoundInfo: 'The page you requested cannot be found',
    pageRestricted: 'Sign in required',
    pageRestrictedInfo: 'Please sign in to see this page',
    signOutRequired: 'Sign out required',
    signOutRequiredInfo: 'Please sign out to see this page',
    playerNotFound: 'Player not found',
    playerNotFoundInfo:
      'The player ID could not be found. The link you followed may be broken, or the page may have been removed.',
    ownProfileError: 'Error loading profile',
    ownProfileErrorInfo: 'An error occurred while retrieving your profile details',
    ownProfileErrorLink: 'Please refresh or try again later',
    appError: 'Something went wrong',
    appErrorInfo: 'An error occurred while processing your request',
    appErrorLink: 'Please refresh or try again later',
    somethingWrong: 'Something went wrong',
    somethingWrongInfo:
      'Please navigate back to the homepage or select another page from the navigation menu',
    alreadyRegistered: 'Account already registered',
    alreadyRegisteredLink: 'Go to sign in',
    activationError: 'Activation error',
    activationErrorInfo: 'An error occurred while activating your account',
    activationErrorLink: 'Click here to contact us',
    activationLoginPrompt: 'Sign in required',
    activationLoginPromptInfo:
      'Please sign in with your credentials to complete account activation',
    signInLink: 'Go to sign in',
    signOutLink: 'Sign me out',
    fastTrackError: 'Something went wrong',
    fastTrackErrorInfo: 'An error occurred while retrieving or updating your details',
    fastTrackErrorLink: 'Click here to contact us',
    recaptchaValidationError: 'Failed reCAPTCHA validation',
    recaptchaValidationErrorLink: 'Refresh page',
    inviteRequired: 'Invite required',
    inviteRequiredInfo:
      'Sorry, you currently need to have an invitation to sign-up to ITF World Tennis Number',
    inviteRequiredLink: 'Back to home page',
    psqUnableSubmit: 'Unable to submit ‘Rate My Game’ questionnaire',
    psqUnableSubmitInfo:
      'You cannot submit a ‘Rate My Game’ questionnaire as you already have an ITF World Tennis Number',
    psqUnableSubmitLink: 'Back to my profile',
    psqNotEligibleInfo:
      'The ‘Rate My Game’ feature is currently unavailable in your country of residence',
    psqUnableSubmitMinAge:
      'You need to be at least %{minAge} to submit a ‘Rate My Game’ questionnaire',
    psqSubmitError: 'Error submitting ‘Rate My Game’ questionnaire',
    psqSubmitErrorInfo:
      'There was an error while submitting your ‘Rate My Game’ questionnaire. Please try again later.',
    psqSubmitErrorLink: 'Back to my profile',
    featureNotAvailable: 'Feature not available',
    featureNotAvailableProAndJuniors:
      'This feature is not available for players with an active junior or professional IPIN.',
    errorInfo: {
      intro: 'Message:',
      location: 'Location:',
      rlog: 'RLOG:',
    },
  },
  strAlerts: {
    updatingDetails: 'Updating details...',
    detailsUpdated: 'Details successfully updated',
    detailsNotUpdated: 'Error updating details',
    avatarNotUploaded: 'Error uploading avatar image',
    actionError: 'Error trying to perform the requested action. Please try again later.',
    removingPlayerWl: 'Removing player from watchlist(s)...',
    playerWlRemoved: 'Removed player from watchlist(s) successfully',
    errorRemovingPlayerWl: 'Error removing player from watchlist(s)',
    addingPlayerWl: 'Adding player to watchlist(s)...',
    playerWlAdded: 'Player added to watchlist(s) successfully',
    errorAddingPlayerWl: 'Error adding player to watchlist(s)',
    managingPlayerWl: {
      success: {
        add: 'Added to ‘%{name}’',
        addPlural: 'Added to %{count} watchlists',
        remove: 'Removed from ‘%{name}’',
        removePlural: 'Removed from %{count} watchlists',
        create: '‘%{name}’ created',
        update: '‘%{name}’ updated',
        updatePlural: '%{count} watchlists updated',
      },
      error: {
        add: 'Error adding to ‘%{name}’',
        addFull: 'Player can’t be added. ‘%{name}’ is full.',
        addPlural: 'Error adding to %{count} watchlists',
        addPluralFull: 'Player can’t be added. %{count} watchlists are full',
        remove: 'Error removing from ‘%{name}’',
        removePlural: 'Error removing from %{count} watchlists',
        create: 'Error creating ‘%{name}’',
        createFull: 'Watchlists limit reached: Could not create ‘%{name}’',
      },
    },
    creatingWl: 'Creating watchlist...',
    wlCreated: 'Watchlist successfully created',
    errorCreatingWl: 'Error while trying to create watchlist',
    deletingWl: 'Deleting watchlist...',
    wlDeleted: 'Watchlist successfully deleted',
    errorDeletingWl: 'Error while trying to delete watchlist',
    renamingWl: 'Renaming watchlist...',
    wlRenamed: 'Watchlist successfully renamed',
    errorRenamingWl: 'Error while trying to rename watchlist',
    approvingSocialMatch: 'Accepting your score...',
    errorApprovingSocialMatch: 'Error while accepting your score',
    socialMatchApproved: 'Score successfully accepted',
    rejectingSocialMatch: 'Rejecting your score...',
    errorRejectingSocialMatch: 'Error while rejecting your score',
    socialMatchRejected: 'Score successfully rejected',
    errorSubmittingSocialMatch: 'Error while submitting your score',
    deletingSocialMatch: 'Deleting your score...',
    errorDeletingSocialMatch: 'Error while deleting your score',
    socialMatchDeleted: 'Score successfully deleted',
    socialMatchAlreadyDeleted: 'It looks like this match has been deleted by the user',
    socialMatchAlreadyApproved: 'It looks like this match has already been approved by the user',
    copiedToClipboard: 'Copied to clipboard!',
    failedCopyingToClipboard: 'Failed to copy to clipboard',
    errorPlayerSearch: 'Error while searching for players',
    csvDownload: {
      success: 'CSV download successful',
      error: 'CSV download error',
    },
  },
  strWatchlists: {
    overview: {
      title: 'My watchlists',
      subtitle: '%{count}/%{max} watchlists created',
      panelEmpty: {
        title: 'No watchlists yet',
        info: 'Search for a player and use the star icon to add them to a watchlist.',
        button: 'Start searching',
      },
      card: {
        count: '%{count}/%{max} players',
      },
      createBtn: 'Create new watchlist',
    },
    detail: {
      count: '%{count}/%{max} players',
      panelEmpty: {
        title: 'Your watchlist is empty',
      },
      addBtn: 'Add players',
    },
    addOrManageModal: {
      add: {
        title: 'Add to watchlist',
        watchlistFull: '(watchlist is full)',
      },
      manage: {
        title: 'Select a watchlist',
      },
      create: {
        label: 'Create new watchlist',
        charsCount: '%{count}/%{max} characters',
        limitReached:
          'You can’t create new watchlists because you reached the limit (%{count}/%{max}).',
      },
    },
    createModal: {
      title: 'Create a watchlist',
      titleFull: 'Watchlists limit reached',
      defaultLabel: 'Watchlist name',
      info: 'Use watchlists to save players for later.',
      infoFull: 'You cannot create any more watchlists. Please remove one first.',
    },
    renameModal: {
      title: 'Rename watchlist',
      info: 'Choose a different name below to rename the watchlist.',
    },
    deleteModal: {
      title: 'Delete watchlist',
      info: 'Choose a different name below to rename the watchlist.',
    },
    common: {
      averageSinglesWtn: 'Average Singles WTN: %{average}',
      minSinglesWtn: 'Min. Singles WTN: %{min}',
      maxSinglesWtn: 'Max. Singles WTN: %{max}',
    },
  },
}

i18n.fallbacks = true
i18n.translations = { en }

export default i18n
